import fetch from 'auth/FetchInterceptor'

const eventoService = {}

// Buscar eventos por usuario
eventoService.getEventosByUsuario = function (usuarioId) {
  return fetch({
    url: '/eventos',
    method: 'get',
    headers: {
      'idUsuario': usuarioId
    }
  });
}

// Criar novo evento
eventoService.criarEvento = function (usuarioId, eventoData) {
  return fetch({
    url: '/eventos',
    method: 'post',
    data: eventoData,
    headers: {
      'idUsuario': usuarioId
    }
  })
}

// Buscar evento por ID
eventoService.getEventoById = function (eventoId) {
  return fetch({
    url: `/eventos/${eventoId}`,
    method: 'get'
  })
}

// Atualizar evento
eventoService.atualizarEvento = function (eventoId, eventoData) {
  return fetch({
    url: `/eventos/${eventoId}`,
    method: 'put',
    data: eventoData
  })
}

// Excluir evento
eventoService.excluirEvento = function (eventoId) {
  return fetch({
    url: `/eventos/${eventoId}`,
    method: 'delete'
  })
}

// Gerenciar evento ativo no localStorage
eventoService.setEventoAtivo = function (evento) {
  if (!evento || !evento.id) {
    return;
  }

  localStorage.setItem('eventoAtivoId', evento.id);
  localStorage.setItem('apelidoEvento', evento.apelidoEvento || '');
}

eventoService.getEventoAtivoId = function () {
  return localStorage.getItem('eventoAtivoId');
}

eventoService.getApelidoEvento = function () {
  return localStorage.getItem('apelidoEvento');
}

eventoService.clearEventoAtivo = function () {
  localStorage.removeItem('eventoAtivoId');
  localStorage.removeItem('apelidoEvento');
}

export default eventoService;
